import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { i18nReady } from "@/i18n";
import { ThemeProvider } from "@/context/ThemeContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});


const tree = (
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </QueryClientProvider>
);

const rootElement = document.getElementById("root");
// prerender.js injects static SEO HTML into #root + <head> for crawlers. Before
// mounting React we (1) wipe #root so React 18's createRoot starts on a clean
// node (first click no longer swallowed) and (2) strip the prerendered
// [data-prerender] head tags so react-helmet-async owns the <head> alone. This
// prevents duplicate SEO tags AND the "removeChild of null" crash that happened
// when an external dedup script removed tags out from under helmet, freezing
// navigation until a second click. Crawlers still read the SEO from raw HTML.
rootElement.innerHTML = "";
document.head.querySelectorAll("[data-prerender]").forEach((el) => el.remove());
const root = ReactDOM.createRoot(rootElement);
// Load the URL's language bundle (if not Dutch) before the first render to avoid a flash of Dutch text.
i18nReady.finally(() =>
  root.render(
    <React.StrictMode>{tree}</React.StrictMode>,
  ),
);
